import React, { useState } from 'react';

export default function Tab({ children, className = '', variant = 'default' }) {
  // State to keep track of the active tab
  const [activeTab, setActiveTab] = useState(0);
  const tabRootClassName = `app-tabset app-tabset--${variant} ${className}`.trim();

  return (
    <div className={tabRootClassName}>
      <ul className="nav box-teb-menu app-tabset__nav" id="myTab3" role="tablist">
        {React.Children.map(children, (child, index) => (
          <li 
            className="nav-item teb-item app-tabset__item"
            role="presentation" key={index}
          >
            {(() => {
              const { label, tabIcon, tabSubtitle } = child.props;

              return (
            <button
              className={`nav-link teb-link app-tabset__button ${index === activeTab ? 'active' : ''}`}
              id={`pills-tab-${index}`}
              data-bs-toggle="pill"
              data-bs-target={`#pills-content-${index}`}
              type="button"
              role="tab"
              aria-controls={`pills-content-${index}`}
              aria-selected={index === activeTab}
              onClick={() => setActiveTab(index)} // Update active tab on click
            >
              {tabIcon && <span className="app-tabset__button-icon-shell">{tabIcon}</span>}
              <span className="app-tabset__button-copy">
                <span className="app-tabset__button-title">{label}</span>
                {tabSubtitle && <span className="app-tabset__button-subtitle">{tabSubtitle}</span>}
              </span>
            </button>
              );
            })()}
          </li>
        ))}
      </ul>
      <div className="tab-content app-tabset__content" id="pills-tabContent">
        {React.Children.map(children, (child, index) => {
          if (index !== activeTab) {
            return null;
          }

          // Extract custom props and create clean element
          const { label, tabIcon, tabSubtitle, ...domProps } = child.props;
          const cleanChild = React.cloneElement(child, {
            label: undefined,
            tabIcon: undefined,
            tabSubtitle: undefined,
            ...domProps
          });

          return (
            <div
              className="tab-pane show active app-tabset__panel"
              id={`pills-content-${index}`}
              role="tabpanel"
              aria-labelledby={`pills-tab-${index}`}
              tabIndex="0"
            >
              {cleanChild}
            </div>
          );
        })}
      </div>
    </div>
  );
}
